import { Combobox } from "@newsela/angelou";
import { useEffect, useState } from "react";
import useSchoolThroughUserQuery from "@/teacher/hooks/useSchoolThroughUserQuery";
import { School } from "@/api/catalogs/mockData/schoolThroughUserMock";
import {
  schoolSelectorContainerStyle,
  schoolSelectorStyle,
} from "@/directory/DirectoryTable/SchoolSelector/SchoolSelector.style";

export interface SchoolSelectorProps {
  onChangeSchool: (school: School | undefined | null) => void;
}

const SchoolSelector = ({ onChangeSchool }: SchoolSelectorProps) => {
  const [selected, setSelected] = useState<School | undefined | null>(
    undefined,
  );

  const {
    data: schools = [],
    isLoading: isLoadingSchool,
    isError: isErrorSchool,
  } = useSchoolThroughUserQuery("me");

  useEffect(() => {
    if (schools && schools.length > 0) {
      onChangeSchool(schools[0] as unknown as School);
      setSelected(schools[0] as unknown as School);
    }
  }, [schools]);

  if (isLoadingSchool) {
    return null;
  }

  if (isErrorSchool) {
    return <div>There was an error loading the schools</div>;
  }

  if (schools.length === 1) {
    return null;
  }

  return (
    <div css={schoolSelectorContainerStyle}>
      <Combobox
        __cssFor={schoolSelectorStyle}
        label="School"
        items={schools}
        itemToString={(item) => (item ? item.name : "")}
        selectedItem={selected}
        onSelectedItemChange={(e) => {
          onChangeSchool(e.selectedItem);
          setSelected(e.selectedItem);
        }}
      />
    </div>
  );
};

export default SchoolSelector;
